import { getClientListRouteLocation } from "@/domains/-coachee/-list/routes";
import { reactive } from "vue";
import { RouteLocationRaw } from "vue-router";

type BreadcrumbSegment = {
    label: string;
    route?: RouteLocationRaw
}

export type PageHeaderConfig = {
    showHome?: boolean;
    showTitle?: boolean;
    title?: string;
    breadcrumb?: BreadcrumbSegment[];
}

export class Breadcrumb{
    private _segments: BreadcrumbSegment[];

    constructor() {
        this._segments = [];
    }

    setConfig(config: BreadcrumbSegment[]): void{
        this._segments = config
    }

    addSegment(segment: BreadcrumbSegment): void{
        this._segments.push(segment)
    }

    get segments(): BreadcrumbSegment[]{
        return this._segments
    }
}

export class PageHeader{
    private _breadcrumb:Breadcrumb;
    private _showHome: boolean;
    private _showTitle: boolean;
    private _title: string;

    constructor() {
        this._breadcrumb = new Breadcrumb()
        this._showHome = false
        this._showTitle = false
        this._title = ''
    }

    setConfig(config: PageHeaderConfig): void{
        if(config.showHome !== undefined) this._showHome = config.showHome
        if(config.showTitle !== undefined) this._showTitle = config.showTitle
        if(config.title !== undefined) this._title = config.title
        if(config.breadcrumb !== undefined) this._breadcrumb.setConfig(config.breadcrumb)
    }

    resetConfig(): void{
        this._showHome = false
        this._showTitle = false
        this._title = ''
        this._breadcrumb.setConfig([])
    }

    get breadcrumb(): Breadcrumb{
        return this._breadcrumb
    }

    get showHome(): boolean{
        return this._showHome
    }

    get showTitle(): boolean{
        return this._showTitle
    }

    get title(): string{
        return this._title
    }
}

let pageHeader: PageHeader;

export function usePageHeader(): PageHeader {
  if (!pageHeader)
    pageHeader = reactive(new PageHeader()) as PageHeader;

  return pageHeader;
}